import type { MouseEventHandler, Ref } from 'react';
import type { IconProps, IconSize } from '../Icon/Icon';
import type { IconGlyph } from '../Icon/IconGlyph';
import type { InteractiveAtomSize } from '../utils/InteractiveAtomProps';

export type SystemButtonSize = InteractiveAtomSize | 'x-small';

export const fromSystemButtonToIconSize: {
  [Key in SystemButtonSize]: IconSize;
} = {
  'x-small': 'sm',
  small: 'base',
  default: 'lg',
  large: 'xl',
};

export type SystemButtonProps = {
  icon: IconGlyph;
  iconProps?: Omit<IconProps, 'glyph'>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
  buttonRef?: Ref<HTMLButtonElement>;
  size?: SystemButtonSize;
  loading?: boolean;
  dataTestId?: string;
};
